<template>
  <v-container>
    <v-row justify="center" align="center">
      
      
      <v-col cols="12" sm="8" md="4" class="login">
           <img
              src="../../assets/log.png"
              alt="Vue Material Admin"
              height="140px"
              width="155px"
            />
        
        <v-card class="elevation-0">
          
          <v-app-bar text color="primary">
            <v-toolbar-title class="titleApp"
              >Acceso a módulo administrativo</v-toolbar-title
            >
          </v-app-bar>
          <v-card-text>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-text-field
                v-model="email"
                prepend-icon="person"
                name="login"
                label="Correo electrónico"
                type="text"
                :rules="[form.required, form.email]"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Contraseña"
                type="password"
                :rules="[form.required]"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                v-shortkey="['enter']"
                @shortkey="submit()"
                @click="submit()"
                rounded
                large
                class="my-2"
                color="primary"
                >Entrar</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { auth } from "../../firebase.config.js";

export default {
  name: "Login",
  data: () => ({
    form: {
      valid: false,
      required: (v) => !!v || "Este campo es necesario",
      email: (v) => /.+@.+/.test(v) || "El correo electrónico debe ser válido",
    },
    email: null,
    password: null,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then((response) => {
            this.$router.replace("/admin/dashboard/InitialPage");
          })
          .catch((error) => {
            this.$emit("show-snackbar", "Verifique el correo o la contraseña.");
          });
      }
    },
  },
};
</script>
<style scoped>
.titleApp {
  color: white;
}
.login {
  margin-top: 20%;
}
</style>
